<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/proprietario"> Cadastro/Equipamento/Proprietários </router-link>
      <label class="labelBar"> / </label>
      <label class="labelBar"> Criar</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Proprietário *"
              v-model="nome"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Proprietário é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="CNPJ *"
              v-model="cnpj"
              v-uppercase
              v-mask="['##.###.###/####-##']"
              :counter="18"
              :rules="[(v) => !!v || 'O CNPJ é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Contato *"
              v-model="contato"
              :counter="100"
              :rules="[(v) => !!v || 'O Contato é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Celular *"
              v-model="celular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              :rules="[(v) => !!v || 'O Celular é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn to="/proprietario" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarProprietarioAsync } from "@/services/proprietarioService";

export default {
  name: "criarPrprietario",
  data: () => ({
    overlay: false,
    nome: null,
    cnpj: null,
    contato: null,
    celular: null,
  }),
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarProprietarioAsync(
          this.nome,
          this.cnpj,
          this.contato,
          this.celular
        );
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/proprietario");
        }
      }
    },
  },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>